import type { IStatusProps } from 'shared/ui/Status'
import { type ICallingListResponse } from 'entities/AICalling/api/types'

const STATUSES: Record<ICallingListResponse['status'], IStatusProps> = {
  draft: {
    title: 'Draft',
    icon: 'draft',
    emphasis: 'high',
    intent: 'neutral',
  },
  active: {
    title: 'Active',
    icon: 'check2',
    emphasis: 'high',
    intent: 'positive',
  },
  disabled: {
    title: 'Disabled',
    icon: 'minusCircle',
    emphasis: 'high',
    intent: 'neutral',
  },
}

export const getAiCallingStatus = (
  status: ICallingListResponse['status']
): IStatusProps | undefined => STATUSES[status]
